import { $ } from "../shared/globals.js";

export function createTigerWalkFeature({ context, CONFIG, prefersReducedMotion }) {
    const { $tigerFrames, $tigerStatic } = context;
    const totalFrames = CONFIG.tigerWalkFrames;

    let tigerWalkInterval = null;
    let tigerWalkTimeout = null;
    let currentTigerFrame = 1;
    let tigerWalkingEnabled = false;
    let isPaused = false;

    function startTigerWalking() {
        if (tigerWalkingEnabled || prefersReducedMotion) return;

        tigerWalkingEnabled = true;
        $tigerStatic.removeClass("active");
        $(".tiger-frame-1").addClass("active");
        runWalkCycle();
    }

    function runWalkCycle() {
        if (!tigerWalkingEnabled) return;

        isPaused = false;

        tigerWalkInterval = window.setInterval(() => {
            $tigerFrames.removeClass("active");
            currentTigerFrame += 1;

            if (currentTigerFrame > totalFrames) {
                currentTigerFrame = 1;
                window.clearInterval(tigerWalkInterval);
                tigerWalkInterval = null;
                isPaused = true;
                $(".tiger-frame-1").addClass("active");

                tigerWalkTimeout = window.setTimeout(() => {
                    if (tigerWalkingEnabled) {
                        runWalkCycle();
                    }
                }, CONFIG.tigerWalkPauseDuration);

                return;
            }

            $(`.tiger-frame-${currentTigerFrame}`).addClass("active");
        }, CONFIG.tigerWalkFrameRate);
    }

    function stopTigerWalking() {
        if (tigerWalkInterval) {
            window.clearInterval(tigerWalkInterval);
            tigerWalkInterval = null;
        }

        if (tigerWalkTimeout) {
            window.clearTimeout(tigerWalkTimeout);
            tigerWalkTimeout = null;
        }

        tigerWalkingEnabled = false;
        isPaused = false;
    }

    return {
        startTigerWalking,
        stopTigerWalking,
        isPaused() {
            return isPaused;
        },
    };
}
